import MainScreenWrapper from './mainScreenWrapper'

export default MainScreenWrapper